import { ClubBookingApiClient } from "../../common/api/ClubBookingApiClient";
import { UserPermissions } from "../../model/members/UserPermissions";

export type AuthSyncStatus = 'Success' | 'NewUser' | 'EmailMismatch' | 'Error';

export interface AuthSyncResult {
    status: AuthSyncStatus;
    permissions: UserPermissions;
    requiresTokenRefresh: boolean;
    errorMessage?: string | null;
}

export class PermissionsService extends ClubBookingApiClient {

    /**
     * Single consolidated post-login sync. Replaces the two-endpoint
     * `/auth/permissions` + `/auth/validate` flow with one idempotent call.
     *
     * The backend performs a cascading member lookup (Auth0 ID -> membership ID -> email),
     * corrects any DB/Auth0 drift, and returns the user permissions plus a flag indicating
     * whether a token refresh is needed.
     */
    async syncAuth(): Promise<AuthSyncResult> {
        return this.post<AuthSyncResult>('/auth/sync', undefined, {
            showLoading: false,
            showError: false,
            showSuccess: false,
        });
    }
}
